import { Alert } from '@mui/material';
import { usePhrase } from '@/hooks';
import { ACCOUNT_CONTACT_DETAILS_PHRASES } from '@/consts/phrases/accountPhrases';

const alertStyles = { p: '0 12px', border: '1px solid rgba(0,0,0,0.05)' };

const Confirmed = () => {
    const { t } = usePhrase();
    return (
        <Alert
            severity="success"
            sx={(theme) => ({ ...alertStyles, color: theme.colors.other.text.success })}
        >
            {t(ACCOUNT_CONTACT_DETAILS_PHRASES.CONFIRMED)}
        </Alert>
    );
};

const Pending = (props: { phrase?: string }) => {
    const { t } = usePhrase();
    return (
        <Alert
            severity="warning"
            sx={(theme) => ({ ...alertStyles, color: theme.colors.other.text.warning })}
        >
            {props.phrase
                ? props.phrase
                : t(ACCOUNT_CONTACT_DETAILS_PHRASES.VERIFICATION_IN_PROGRESS)}
        </Alert>
    );
};

export enum ConfirmationStatus {
    'Confirmed',
    'Pending',
}

interface ConfirmationBoxProps {
    status: ConfirmationStatus;
    pendingPhrase?: string;
}

export const ConfirmationBox = (props: ConfirmationBoxProps) => (
    <>
        {props.status === ConfirmationStatus.Pending && <Pending phrase={props.pendingPhrase} />}
        {props.status === ConfirmationStatus.Confirmed && <Confirmed />}
    </>
);
